module.exports = {
	context: {
		container: {
			title: 'container'
		},
		component: {
			cardDefault: [
				{title:'Nyhet', header: 'Monica Dahlgren', content:'Expert inom Lorem ipsum	', date:'19-03-14', url:'#', bgColor:'white'},
				{title:'Nyhet', header: 'FMV får uppdrag att ingå avtal med USA om luftvärns-systemet Patriot', content:'', date:'19-07-14', url:'#', bgColor:'medium-grey', bgImage:'/images/demo-soldat-1.jpg'},
				{title:'Nyhet', header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', content:'', date:'18-03-14', url:'#', bgColor:'beige'},
				{title:'Nyhet', header: 'Ett stort steg mot gemensamt strids-uniformssystem i Norden', date:'19-03-14', url:'#', bgColor:'medium-grey'},
				{title:'Nyhet', header: 'FMV får uppdrag att ingå avtal med USA om luftvärns-systemet Patriot', date:'17-03-14', url:'#', bgColor:'beige'},
				{title:'Nyhet', header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', date:'19-03-14', url:'#', bgColor:'greyish-brown'},
				{title:'Nyhet', header: 'Ett stort steg mot gemensamt strids-uniformssystem i Norden', date:'19-01-14', url:'#', bgColor:'beige'},
				{title:'Nyhet', header: 'FMV får uppdrag att ingå avtal med USA om luftvärns-systemet Patriot', date:'19-03-01', url:'#', bgColor:'medium-grey'},
				{title:'Nyhet', header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', date:'19-01-28', url:'#', bgColor:'greyish-brown'},
			]
		}
	},
	variants: [
		{
			name: 'with featured article',
			context: {
				container: {
					title: 'container',
					hasFeatured: true
				},
				component: {
					cardDefault: [
						{title:'Nyhet', header: 'Monica Dahlgren', content:'Expert inom Lorem ipsum	', date:'19-03-14', url:'#', bgColor:'white', isFeatured: true},
						{title:'Nyhet', header: 'FMV får uppdrag att ingå avtal med USA om luftvärns-systemet Patriot', content:'', date:'19-07-14', url:'#', bgColor:'medium-grey', bgImage:'/images/demo-soldat-1.jpg'},
						{title:'Nyhet', header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', content:'', date:'18-03-14', url:'#', bgColor:'beige'},
						{title:'Nyhet', header: 'Ett stort steg mot gemensamt strids-uniformssystem i Norden', date:'19-03-14', url:'#', bgColor:'medium-grey'},
				        {title:'Nyhet', header: 'FMV får uppdrag att ingå avtal med USA om luftvärns-systemet Patriot', date:'17-03-14', url:'#', bgColor:'beige'},
				        {title:'Nyhet', header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', date:'19-03-14', url:'#', bgColor:'greyish-brown'},
				        {title:'Nyhet', header: 'Ett stort steg mot gemensamt strids-uniformssystem i Norden', date:'19-01-14', url:'#', bgColor:'beige'},
				        {title:'Nyhet', header: 'FMV får uppdrag att ingå avtal med USA om luftvärns-systemet Patriot', date:'19-03-01', url:'#', bgColor:'medium-grey'},
				        {title:'Nyhet', header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', date:'19-01-28', url:'#', bgColor:'greyish-brown'},
					]
				}
			}
		}
	]
};
